function getRecentProductsCookie() {
  const name = 'recently_viewed_products';
  const matches = document.cookie.match(new RegExp(
    '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function getRecentlyViewedProducts() {
  const cookie = getRecentProductsCookie();
  return cookie ? cookie.split(',') : [];
}

function getCurrentProductHandle() {
  const el = document.getElementsByName('product-info')[0];
  return el ? el.getAttribute('data-product-handle') : '';
}

function addRecentlyViewedProduct() {
  const productHandle = getCurrentProductHandle();
  const viewedProducts = getRecentlyViewedProducts();
  const index = viewedProducts.indexOf(productHandle);

  if (index > -1) viewedProducts.splice(index, 1);
  viewedProducts.unshift(productHandle);
  if (viewedProducts.length > 10) viewedProducts.splice(10);

  document.cookie = 'recently_viewed_products=' + viewedProducts.toString() + '; path=/; max-age=2592000;';
}

function resizeShopifyImage(src, size) {
  return src.replace(/(\.[^.?]+)(\?|$)/, '_' + size + '$1$2');
}

function trackEvent(eventName, params) {
  if (typeof gtag !== 'function') return;
  gtag('event', eventName, params);
}

function buildGAItem(product, index) {
  return {
    item_id: product.id.toString(),
    item_name: product.title,
    price: product.price / 100,
    index: index + 1,
    item_list_id: 'recently_viewed',
    item_list_name: 'Recently Viewed'
  };
}

async function displayRecentlyViewedProducts() {
  const currentProductHandle = getCurrentProductHandle();
  const viewedProducts = getRecentlyViewedProducts().filter(h => h !== currentProductHandle);

  if (viewedProducts.length === 0) return;

  const template = document.getElementById('rvp-card-template');
  const grid = document.getElementById('recently-viewed-grid');
  const section = document.getElementById('recently-viewed-products-section');

  if (!template || !grid || !section) return;

  const GBPound = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

  const fetchResults = await Promise.allSettled(
    viewedProducts.map(handle =>
      fetch(window.Shopify.routes.root + 'products/' + handle + '.js').then(r => r.json())
    )
  );

  let displayed = 0;
  const displayedProducts = [];

  for (const result of fetchResults) {
    if (displayed >= 6) break;
    if (result.status !== 'fulfilled') continue;

    const data = result.value;
    if (!data || !data.available) continue;

    const card = template.content.cloneNode(true);
    const position = displayed;

    card.querySelectorAll('.rvp-link, .rvp-name-link').forEach(el => el.setAttribute('href', data.url));
    card.querySelector('.rvp-name-link').textContent = data.title;
    card.querySelector('.rvp-price').textContent = GBPound.format(data.price / 100);

    if (data.media && data.media.length > 0) {
      const img = card.querySelector('.rvp-image');
      img.setAttribute('src', resizeShopifyImage(data.media[0].src, '300x300'));
      img.setAttribute('alt', data.media[0].alt || data.title);
      img.removeAttribute('style');
    }

    // Attach select_item tracking before the card is moved into the DOM
    card.querySelector('.recently-viewed-outer').addEventListener('click', () => {
      trackEvent('select_item', {
        currency: 'GBP',
        item_list_id: 'recently_viewed',
        item_list_name: 'Recently Viewed',
        items: [buildGAItem(data, position)]
      });
    });

    grid.appendChild(card);
    displayedProducts.push(data);
    displayed++;
  }

  if (displayed > 0) {
    section.removeAttribute('style');
    setupViewTracking(displayedProducts);
  }

  if (displayed > 2) {
    setupCarouselArrows();
  }
}

function setupViewTracking(displayedProducts) {
  const section = document.getElementById('recently-viewed-products-section');
  if (!section) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      trackEvent('view_item_list', {
        currency: 'GBP',
        item_list_id: 'recently_viewed',
        item_list_name: 'Recently Viewed',
        items: displayedProducts.map((product, index) => buildGAItem(product, index))
      });
      observer.disconnect();
    });
  }, { threshold: 0.25 });

  observer.observe(section);
}

function setupCarouselArrows() {
  const wrapper = document.getElementById('rvp-carousel-wrapper');
  const grid = document.getElementById('recently-viewed-grid');
  const prevBtn = document.getElementById('rvp-prev');
  const nextBtn = document.getElementById('rvp-next');

  if (!wrapper || !grid || !prevBtn || !nextBtn) return;

  wrapper.classList.add('rvp-has-carousel');

  function updateArrows() {
    prevBtn.disabled = grid.scrollLeft <= 1;
    nextBtn.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
  }

  const cardWidth = grid.clientWidth / 2;

  prevBtn.addEventListener('click', () => {
    grid.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    trackEvent('recently_viewed_carousel_scroll', { direction: 'previous' });
  });

  nextBtn.addEventListener('click', () => {
    grid.scrollBy({ left: cardWidth, behavior: 'smooth' });
    trackEvent('recently_viewed_carousel_scroll', { direction: 'next' });
  });

  grid.addEventListener('scroll', updateArrows, { passive: true });
  updateArrows();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', displayRecentlyViewedProducts);
} else {
  displayRecentlyViewedProducts();
}
